<!-- 조직관리 > 시스템알림관리 상세 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.type')}}<span class="imp">*</span></div>
          <div class="row">
            <div class="radio-group">
              <v-radio-group v-model="type" :name="'type'" >
                <v-radio color="indigo" :label="t('message.systemNotice')" value="1" v-if="user.roles == 'ADMIN1'"></v-radio>
                <v-radio color="indigo" :label="t('message.groupNotice')" value="2" v-if="user.roles == 'ADMIN1' || user.roles == 'ADMIN2'"></v-radio>
                <v-radio color="indigo" :label="t('message.companyNotice')" value="3"></v-radio>
              </v-radio-group>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.title')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input v-bind="inpTitle" v-model="title" :name="'title'" class="size01"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.content')}}<span class="imp">*</span></div>
          <div class="row">
            <div class="txt">
              <quill-editor
                v-model:value="content"
                :options="editorOption"
                @change="onEditorChange($event)"
                @ready="onEditorReady"
              ></quill-editor>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.postStartDate')}}</div>
          <div class="row">
            <c-InputDate v-bind="inpStartDate" v-model="startDate" :name="'startDate'" class="size02" readonly=""/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.postEndDate')}}</div>
          <div class="row">
            <c-InputDate v-bind="inpEndDate" v-model="endDate" :name="'endDate'" class="size02" readonly=""/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.isVisible')}}</div>
          <div class="row">
            <v-switch v-model="showYn" inset hide-details true-value="Y" false-value="N"></v-switch>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.pushNotification')}}</div>
          <div class="row">
            <v-switch v-model="pushYn" inset hide-details true-value="Y" false-value="N"></v-switch>
            <div class="txt02" v-if="pushSendDate">{{t('message.sendDate')}} : {{pushSendDate}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.emailNotification')}}</div>
          <div class="row">
            <v-switch v-model="mailYn" inset hide-details true-value="Y" false-value="N"></v-switch>
            <div class="txt02" v-if="mailSendDate">{{t('message.sendDate')}} : {{mailSendDate}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.createdAt')}}</div>
          <div class="row">
            <div class="txt02">{{inpUploadVal}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.updatedAt')}}</div>
          <div class="row">
            <div class="txt02">{{inpModifyVal}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 v-bind="btnPageList" @click="onClickGoList"/>
      </div>
      <div class="wr">
        <c-btn02 v-bind="btnPageDel" @click="dialogPageDelModel=true"/>
        <c-btn01 v-bind="btnPageModify" @click="validateAll"/>
      </div>
    </div>
  </div>
  <!--삭제버튼-->
  <c-dialog v-model="dialogPageDelModel"
            v-bind="dialogPageDelBind"
            @close="dialogPageDelModel=false"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<style lang="scss" >
</style>
<script setup lang="ts">
import { ref } from 'vue'
import BoardService from "@/services/board.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import {useForm} from "vee-validate";
import * as yup from "yup";
import { quillEditor,Quill } from 'vue3-quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {useRoute} from "vue-router";
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  title: yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const boardIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const type = ref('1')
const title = ref('')
const content = ref('')
const content_ = ref('')
const startDate = ref('')
const endDate = ref('')
const mailSendDate = ref('')
const pushSendDate = ref('')
const showYn = ref('N')
const pushYn = ref('N')
const mailYn = ref('N')
const inpUploadVal = ref('')
const inpModifyVal = ref('')
const dialogPageDelModel = ref(false)
const quillObject:any = ref(null)
const user = ref(JSON.parse(localStorage.getItem('user')))

//ui
const Size = Quill.import("attributors/style/size")
Size.whitelist = ["8px", "10px", "12px", "14px", "18px", "24px", "32px"] // 지원할 폰트 크기 리스트
Quill.register(Size, true)
const Font = Quill.import('formats/font')
Font.whitelist = ['noto-sans', 'noto-sans-kr', 'malgun-gothic', 'sans-serif']
Quill.register(Font, true)

const dialogPageDelBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.confirmAdminDemotion'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const inpTitle = {
  placeholder: t('message.enterTitle'),
  type:'text'
}
const inpStartDate={
  placeholder: t('message.startDate'),
}
const inpEndDate={
  placeholder: t('message.endDate'),
}
const btnPageList = {
  btnText: t('message.list'),
}

const btnPageDel = {
  btnText: t('message.delete'),
}
const btnPageModify = {
  btnText: t('message.registerOrUpdate'),
  btnType: 'submit'
}

//hook
onMounted(() => {
  if (boardIdx) {
    let params = {
      idx: boardIdx
    }

    BoardService.getBoard(params).then(
      (response) => {
        type.value = response.result.type
        title.value = response.result.title
        content.value = response.result.content
        startDate.value = dayjs(response.result.startDate).format('YYYY-MM-DD')
        endDate.value = dayjs(response.result.endDate).format('YYYY-MM-DD')
        showYn.value = response.result.showYn
        pushYn.value = response.result.pushYn
        mailYn.value = response.result.mailYn
        inpUploadVal.value = response.result.regDate
        inpModifyVal.value = response.result.modDate
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

//function
const validateAll = async () => {
  const result = await validate(); // 전체 필드 검증 실행
  if(result.valid)
    handleForm()
}

function handleForm(){
  if(import.meta.env.MODE == 'development') {
    utils.movePage('/organizationalManagement/4/list')
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let params = {
      idx: boardIdx,
      companyIdx:companyIdx,
      type: type.value,
      title: title.value,
      content: content.value,
      startDate: startDate.value=='Invalid Date'?'':startDate.value,
      endDate: endDate.value=='Invalid Date'?'':endDate.value,
      showYn: showYn.value,
      pushYn: pushYn.value,
      mailYn: mailYn.value,
    }

    BoardService.insertBoard(params).then(
      (response) => {
        if(response.success)
          onClickGoList();
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

function onClickGoList(){
  utils.movePage('/organizationalManagement/4/list')
}

function onEditorReady(editorInstance) {
  quillObject.value = editorInstance;
}

const onEditorChange = ({ quill, html, text }) => {
  content_.value = html
}

const imageHandler=async()=>{
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append('companyIdx', localStorage.getItem('companyIdx'));

      try{
      const response = await BoardService.insertImage(formData)
        if (response.success) {
          const quill = quillObject.value
          const range = quill?.getSelection(true)
          if (range) {
            quill.insertEmbed(range.index, 'image', utils.getBaseUrl('editor', response.result.filePath))
            quill.setSelection(range.index + 1);
          }
        }
      }
      catch (error) {
        if(error.status == 403)
          utils.movePage('/login')
        else {
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    }
  }
}

const toDate = (date:string): Date=>{
  const t = new Date(date)
  return new Date(t.getFullYear(), t.getMonth(), t.getDate())
}

const editorOption = {
  placeholder: t('message.content')+t('message.enterContent'),
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{list: 'ordered'}, {list: 'bullet'}],
        [{script: 'sub'}, {script: 'super'}],
        [{indent: '-1'}, {indent: '+1'}],
        [{direction: 'rtl'}],
        [{size: ["8px", "10px", "12px", "14px", "18px", "24px", "32px"]}],
        [{color: []}, {background: []}],
        [{font: ["noto-sans", "noto-sans-kr", "malgun-gothic", "sans-serif"]}],
        [{align: []}],
        ['clean'],
        ['link', 'image', 'video']
      ],
      handlers: {
        image: imageHandler,
      },
    },
  }
}
</script>

<style lang="scss">
.ql-editor strong,
.ql-editor b {
  font-weight: bold !important;
}
.ql-editor em,
.ql-editor i {
  font-style: italic !important;
}
.ql-size-8px {
  font-size: 8px;
}
.ql-size-10px {
  font-size: 10px;
}
.ql-size-12px {
  font-size: 12px;
}
.ql-size-14px {
  font-size: 14px;
}
.ql-size-18px {
  font-size: 18px;
}
.ql-size-24px {
  font-size: 24px;
}
.ql-size-32px {
  font-size: 32px;
}
/* 각 항목 라벨 설정 */
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="8px"]::before {
  content: "8px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}
/* 선택한 항목이 라벨에 표시될 수 있도록 설정 */
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="8px"]::before {
  content: "8px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before {
  content: "12px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before {
  content: "32px";
}
.ql-font-noto-sans {
  font-family: Noto Sans, sans-serif;
}
.ql-font-noto-sans-kr {
  font-family: Noto Sans KR, sans-serif;
}
.ql-font-malgun-gothic {
  font-family: Malgun Gothic, sans-serif;
}
.ql-font-sans-serif {
  font-family: sans-serif, sans-serif;
}
/* 드롭다운 항목 텍스트 */
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans"]::before {
  content: "Noto Sans";
  font-family: Noto Sans, sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans-kr"]::before {
  content: "Noto Sans KR";
  font-family: "Noto Sans KR", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="malgun-gothic"]::before {
  content: "Malgun Gothic";
  font-family: "Malgun Gothic", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
  content: "Sans Serif";
  font-family: sans-serif;
}

/* 선택된 라벨에 표시될 텍스트 */
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans"]::before {
  content: "Noto Sans";
  font-family: Noto Sans, sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans-kr"]::before {
  content: "Noto Sans KR";
  font-family: "Noto Sans KR", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="malgun-gothic"]::before {
  content: "Malgun Gothic";
  font-family: "Malgun Gothic", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before {
  content: "Sans Serif";
  font-family: sans-serif;
}
</style>
